/* mm-sepet.js — sepet sayfası davranışları: adet −/+ ve kaldır (/cart/change.js + Section Rendering), indirim kodu akordeonu
   ve uygulama (/cart/update.js { discount }), teslimat kartı seçimi, mobil yapışkan "Proceed to checkout" çubuğu.
   Her değişiklikten sonra mm:sepet { item_count } gönderilir; mini sepet de aynı yanıtla yenilenir. */
(() => {
  if (customElements.get('mm-sepet')) return;
  const MINI = 'mm-sepet-mini';
  const rota = (ad, yedek) => ((window.routes && window.routes[ad]) || yedek) + '.js';
  const kok = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Ortak kaydırıcıyı yenilenen içerikte kur (assets/mm-kaydirici.js API'si; yoksa olayla)
  const kaydiriciKur = (el) => { if (window.mmKaydirici && window.mmKaydirici.tara) window.mmKaydirici.tara(el); else el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true })); };

  class MmSepet extends HTMLElement {
    connectedCallback() {
      this.bolum = this.dataset.bolum;
      this.addEventListener('click', (e) => this.tik(e));
      this.addEventListener('change', (e) => { if (e.target.matches('.mm-sepet-kargo__radyo')) this.kargoSec(e.target); });
      this.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.matches('[data-mm-promo-girdi]')) { e.preventDefault(); this.promoUygula(e.target.closest('[data-mm-promo]')); } });
      this._dis = (e) => { const d = e.detail || {}; if (d.kaynak === 'sayfa') return; clearTimeout(this._yt); this._yt = setTimeout(() => this.yenile(), 60); };
      document.addEventListener('mm:sepet', this._dis);
      document.addEventListener('mm:sepete-eklendi', this._dis);
      this.yapiskanKur();
    }
    disconnectedCallback() {
      document.removeEventListener('mm:sepet', this._dis);
      document.removeEventListener('mm:sepete-eklendi', this._dis);
      this.gozcu && this.gozcu.disconnect();
    }

    tik(e) {
      const adet = e.target.closest('[data-mm-adet]');
      if (adet) { e.preventDefault(); const s = adet.closest('[data-satir]'); this.degistir(s, parseInt(adet.dataset.mmAdet, 10)); return; }
      const ac = e.target.closest('[data-mm-promo-ac]');
      if (ac) { this.promoAc(ac.closest('[data-mm-promo]')); return; }
      const uygula = e.target.closest('[data-mm-promo-uygula]');
      if (uygula) { this.promoUygula(uygula.closest('[data-mm-promo]')); return; }
      const sil = e.target.closest('[data-mm-promo-sil]');
      if (sil) { this.promoSil(sil.closest('[data-mm-promo]'), sil.dataset.mmPromoSil); }
    }

    /* ----- Section Rendering yanıtını uygula ----- */
    uygula(j) {
      const html = j.sections && j.sections[this.bolum];
      if (html) {
        const d = new DOMParser().parseFromString(html, 'text/html');
        const yeni = d.querySelector('mm-sepet');
        const bosDegisti = yeni && yeni.classList.contains('is-bos') !== this.classList.contains('is-bos');
        if (!yeni) return;
        if (bosDegisti) {
          // boş ↔ dolu geçişi: tüm içerik değişir
          this.classList.toggle('is-bos', yeni.classList.contains('is-bos'));
          this.querySelector('[data-mm-sepet-ic]').replaceWith(yeni.querySelector('[data-mm-sepet-ic]'));
          this.yapiskanKur();
          kaydiriciKur(this);
        } else {
          // yalnız değişen parçalar: ürünler, toplam kutuları, indirim kodu (açık/kapalı durumu korunur)
          yeni.querySelectorAll('[data-mm-parca]').forEach((p) => {
            const eski = this.querySelector(`[data-mm-parca="${p.dataset.mmParca}"]`);
            if (!eski) return;
            if (p.matches('[data-mm-promo]')) {
              const acik = eski.classList.contains('is-acik'); const deger = (eski.querySelector('[data-mm-promo-girdi]') || {}).value || '';
              if (acik) { p.classList.add('is-acik'); const ic = p.querySelector('[data-mm-promo-icerik]'); ic.style.height = 'auto'; p.querySelector('[data-mm-promo-ac]').setAttribute('aria-expanded', 'true'); }
              const g = p.querySelector('[data-mm-promo-girdi]'); if (g && deger && !eski.dataset.temizle) g.value = deger;
            }
            eski.replaceWith(p);
          });
        }
      }
      const mini = j.sections && j.sections[MINI];
      if (mini) {
        const k = document.querySelector('[data-mm-minisepet]');
        const yeni = new DOMParser().parseFromString(mini, 'text/html').querySelector('[data-mm-mini-icerik]');
        const eski = k && k.querySelector('[data-mm-mini-icerik]');
        if (yeni && eski) { eski.replaceWith(yeni); kaydiriciKur(yeni); }
      }
      const n = typeof j.item_count === 'number' ? j.item_count : null;
      if (n !== null) document.dispatchEvent(new CustomEvent('mm:sepet', { detail: { item_count: n, kaynak: 'sayfa' } }));
    }

    async istek(yol, govde) {
      const r = await fetch(yol, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ sections: [this.bolum, MINI], sections_url: window.location.pathname }, govde))
      });
      const j = await r.json();
      if (!r.ok || j.status) { const err = new Error(j.description || j.message || 'hata'); err.yanit = j; throw err; }
      return j;
    }

    /* ----- Adet / kaldır ----- */
    async degistir(satir, adet) {
      if (!satir || isNaN(adet) || adet < 0) return;
      const liste = this.querySelector('[data-mm-parca="urunler"]');
      liste && liste.classList.add('is-yukleniyor');
      const hata = satir.querySelector('[data-mm-satir-hata]'); if (hata) { hata.hidden = true; hata.textContent = ''; }
      try {
        const j = await this.istek(rota('cart_change_url', `${kok()}cart/change`), { line: parseInt(satir.dataset.satir, 10), quantity: adet });
        this.uygula(j);
      } catch (e) {
        liste && liste.classList.remove('is-yukleniyor');
        const h = this.querySelector(`[data-satir="${satir.dataset.satir}"] [data-mm-satir-hata]`);
        if (h) { h.textContent = e.message && e.message !== 'hata' ? e.message : this.dataset.hata; h.hidden = false; }
      }
    }

    /* Dışarıdan (mini sepet / ürün eklendi) değişiklik: bölümü yeniden çiz */
    async yenile() {
      try {
        const r = await fetch(`${window.location.pathname}?sections=${this.bolum},${MINI}`);
        const s = await r.json();
        const d = new DOMParser().parseFromString(s[this.bolum] || '', 'text/html');
        const yeni = d.querySelector('mm-sepet'); if (!yeni) return;
        this.uygula({ sections: { [this.bolum]: s[this.bolum] } });
      } catch (e) { /* sessiz */ }
    }

    /* ----- İndirim kodu ----- */
    promoAc(kutu, ac) {
      if (!kutu) return;
      const ic = kutu.querySelector('[data-mm-promo-icerik]'); const btn = kutu.querySelector('[data-mm-promo-ac]');
      const acik = ac === undefined ? !kutu.classList.contains('is-acik') : ac;
      const h = ic.scrollHeight;
      if (acik) {
        kutu.classList.add('is-acik'); ic.style.height = h + 'px';
        const bitti = () => { if (kutu.classList.contains('is-acik')) ic.style.height = 'auto'; ic.removeEventListener('transitionend', bitti); };
        ic.addEventListener('transitionend', bitti);
        setTimeout(() => { const g = kutu.querySelector('[data-mm-promo-girdi]'); g && g.focus({ preventScroll: true }); }, 50);
      } else {
        ic.style.height = h + 'px'; void ic.offsetHeight;
        kutu.classList.remove('is-acik'); ic.style.height = '0px';
      }
      btn.setAttribute('aria-expanded', acik ? 'true' : 'false');
    }
    promoHata(kutu, metin) {
      const p = kutu.querySelector('[data-mm-promo-hata]'); const g = kutu.querySelector('[data-mm-promo-girdi]');
      if (p) { p.textContent = metin || ''; p.hidden = !metin; }
      g && g.classList.toggle('is-hatali', !!metin);
    }
    kodlar(kutu) { return (kutu.dataset.kodlar || '').split(',').map((x) => x.trim()).filter(Boolean); }
    async promoUygula(kutu) {
      if (!kutu) return;
      const g = kutu.querySelector('[data-mm-promo-girdi]'); const kod = (g.value || '').trim();
      if (!kod) { this.promoHata(kutu, this.dataset.promoHata); g.focus(); return; }
      const btn = kutu.querySelector('[data-mm-promo-uygula]'); btn.classList.add('is-yukleniyor');
      this.promoHata(kutu, '');
      const onceki = this.kodlar(kutu);
      try {
        const j = await this.istek(rota('cart_update_url', `${kok()}cart/update`), { discount: [...onceki.filter((k) => k.toLowerCase() !== kod.toLowerCase()), kod].join(',') });
        const kayit = (j.discount_codes || []).find((d) => (d.code || '').toLowerCase() === kod.toLowerCase());
        if (kayit && kayit.applicable === false) {
          // geçersiz kod: sepetten geri al, hatayı göster
          const geri = await this.istek(rota('cart_update_url', `${kok()}cart/update`), { discount: onceki.join(',') });
          this.uygula(geri);
          const yeni = this.querySelector(`[data-mm-parca="${kutu.dataset.mmParca}"]`) || kutu;
          this.promoHata(yeni, this.dataset.promoHata);
          const g2 = yeni.querySelector('[data-mm-promo-girdi]'); if (g2) g2.value = kod;
        } else if (!j.discount_codes && !j.sections) {
          // API indirim kodlarını desteklemiyorsa Shopify'ın /discount/<kod> yönlendirmesi
          window.location.href = `${kok()}discount/${encodeURIComponent(kod)}?redirect=${encodeURIComponent(window.location.pathname)}`;
        } else {
          kutu.dataset.temizle = '1';
          this.uygula(j);
          const yeni = this.querySelector(`[data-mm-parca="${kutu.dataset.mmParca}"]`);
          const g3 = yeni && yeni.querySelector('[data-mm-promo-girdi]'); if (g3) g3.value = '';
        }
      } catch (e) {
        btn.classList.remove('is-yukleniyor');
        this.promoHata(kutu, this.dataset.promoHata);
      }
    }
    async promoSil(kutu, kod) {
      if (!kutu) return;
      const kalan = this.kodlar(kutu).filter((k) => k !== kod);
      try { this.uygula(await this.istek(rota('cart_update_url', `${kok()}cart/update`), { discount: kalan.join(',') })); } catch (e) { this.promoHata(kutu, this.dataset.hata); }
    }

    /* ----- Teslimat kartları (bilgi amaçlı seçim) ----- */
    kargoSec(radyo) {
      this.querySelectorAll('[data-mm-kargo]').forEach((k) => k.classList.toggle('is-secili', k.contains(radyo)));
    }

    /* ----- Mobil yapışkan ödeme çubuğu: sayfadaki ödeme kutusu görünmüyorken ----- */
    yapiskanKur() {
      this.gozcu && this.gozcu.disconnect();
      const bar = this.querySelector('[data-mm-yapiskan]'); const hedef = this.querySelector('[data-mm-odeme]');
      if (!bar || !hedef || !('IntersectionObserver' in window)) return;
      this.gozcu = new IntersectionObserver(([g]) => {
        const goster = !g.isIntersecting && g.boundingClientRect.top > 0;
        bar.classList.toggle('is-acik', goster);
        const b = bar.querySelector('button'); b && (b.tabIndex = goster ? 0 : -1);
      });
      this.gozcu.observe(hedef);
    }
  }
  customElements.define('mm-sepet', MmSepet);
})();
